module.exports = __webpack_public_path__ + "assets/img/warrior-name-1b89cd1b.png";